<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section px-0">
    <div class="row">
      <div class="full-map-section">
        <!-- <img src="../../../assets/images/ancetry/neanderthals-banner3.png" alt="" /> -->
        <div class="map-container-row">
          <Map v-if="hasMounted && mode === 'map'" :map-data="mapData" :map-data-two="mapDataTwo"
            :map-points="sitesGeoJson" :closest-sample="archaicResult?.neanderthal?.closest_sample" />
          <div class="map-detail">
            <ul class="world-wide-area">
              <li class="neanderthal-area">Neanderthal Area</li>
              <li class="denisovan-area">Denisovan Area</li>
              <li class="neanderthal-site">Neanderthal Site</li>
              <li class="denisovan-site">Denisovan Site</li>
              <li class="neanderthal-denisovan-site" style="grid-column: 1 / -1;">Neanderthal & Denisovan Site</li>
              <li class="closest-sample-site" style="grid-column: 1 / -1;">Closest Neanderthal Sample Site</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="map-detail-section">
          <div class="map-advt">
            <!-- <img src="../../../assets/images/ancetry/neanderthals-banner4.png" alt="" /> -->
          </div>
          <div class="location-detail">
            <h3 class="mb-3 mb-sm-3 text-start ml-0 mt-0 fw-bolder text-blk">
              {{ neanderthal.heading }}
            </h3>
            <div class="archaic-box-row-container">
                <figure class="float-right-img">
                <img src="../../assets/images/Neatherland/Untitled (1).png" alt="" />
                </figure>
              <div v-html="neanderthal.text" ></div>
              <!-- <div>
                <img src="../../assets/images/Neatherland/Frame 1 (4).png" alt="" />
              </div> -->
            </div>

            <!-- <div class="archaic-box-row-container">
              <div>
                <img src="../../assets/images/Neatherland/Frame 1 (4).png" alt="" />
              </div>
            </div> -->
          </div>

          <div class="map-advt">
            <!-- <img src="../../../assets/images/ancetry/neanderthals-banner5.png" alt="" /> -->
          </div>
          <div class="location-detail">
            <h3 class="mb-3 mb-sm-3 text-start ml-0 mt-0 fw-bolder text-blk">
              {{ denisovan.heading }}
            </h3>
            <div class="archaic-box-row-container">
              <figure class="float-right-img">
                <img class="rounded" :src="denisovan.mainImage.urlRaw" :alt="denisovan.mainImage.title" />
              </figure>
              <div v-html="denisovan.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../styles/pages/ancentry/neanderthal-main.scss";
import "../../styles/pages/archaicmap.scss";

import { ref, onMounted } from "vue";
// import Sidebar from "@/components/Sidebar.vue";
// import VikingOverviewCard from "../vikings/VikingsOverviewCard.vue";
import { getArchaicNeanderthal, getArchaicDenisovan } from "@/services/archaic";
import Map from "./ArchaicGeoJsonMap.vue";
// import PageLoader from "@/components/PageLoader.vue";
// import Tabs from "../vikings/VikingMapTabs.vue";
import neanderthalGeoJson from "./neanderthalGeoJson.json";
import denisovanGeoJson from "./denisovanGeoJson.json";
import sitesGeoJson from "./sitesGeoJson.json";
// import MobileContent from "@/components/ancestry/MobileContent.vue";

export default {
  props: { archaicResult: Object },
  components: { Map },
  setup() {
    const hasMounted = ref(false);
    const loadingStatus = ref("loading");
    const neanderthal = ref({});
    const denisovan = ref({});
    const mode = ref("map");
    onMounted(async () => {
      neanderthal.value = await getArchaicNeanderthal();
      denisovan.value = await getArchaicDenisovan();
      loadingStatus.value = "loaded";
      hasMounted.value = true; // if we don't do this then map centering is thrown off by the sidebar
    });
    return {
      loadingStatus,
      neanderthal,
      denisovan,
      hasMounted,
      mode,
      mapData: JSON.stringify(neanderthalGeoJson),
      mapDataTwo: JSON.stringify(denisovanGeoJson),
      sitesGeoJson: JSON.stringify(sitesGeoJson),
    };
  },
};
</script>
<style lang="scss">
.float-right-img{
  @media screen  and (min-width: 993px){
    padding-inline: 30px;
    padding-bottom: 30px;
    float: right;
  }
  img{
    max-width: 567px;
    width: 100%;
    display: block;
  }
  .rounded{
    border-radius: 20px !important;
  }
}
</style>
